window.app.directive("dayHeader", [
  function() {
    return {
      restrict: "A",
      scope: false,
      template: function() {
        return window.isMobile
          ? require("./day-header-mobile.html")
          : require("./day-header.html");
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/day-header/day-header.js